/**
 * Google Tag (gtag.js) loader.
 *
 * Reads tag IDs from build-time env vars:
 *   • REACT_APP_GTAG_ID            — primary Google Tag / GA4 ID
 *                                    (e.g. "GT-XXXXXXX" or "G-XXXXXXXXXX")
 *   • REACT_APP_GTAG_ADS_ID        — optional Google Ads account
 *                                    (e.g. "AW-1234567890")
 *   • REACT_APP_GTAG_ADS_CONVERSION — optional Google Ads conversion target
 *                                    with label (e.g. "AW-1234567890/abcDEF")
 *                                    Used as send_to in the conversion event.
 *
 * If REACT_APP_GTAG_ID is unset, this module is a no-op (production-safe).
 */

const TAG_ID = process.env.REACT_APP_GTAG_ID;
const ADS_ID = process.env.REACT_APP_GTAG_ADS_ID;
const ADS_CONVERSION = process.env.REACT_APP_GTAG_ADS_CONVERSION;

let initialised = false;

export function initGtag() {
  if (initialised) return;
  if (!TAG_ID) return;
  initialised = true;

  // 1. Inject the loader script (one tag is enough — gtag config calls handle the rest)
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(TAG_ID)}`;
  document.head.appendChild(script);

  // 2. Bootstrap the dataLayer + gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", TAG_ID, { anonymize_ip: true });

  // 3. Also configure the Google Ads account so it can attribute events from this site
  if (ADS_ID) {
    gtag("config", ADS_ID);
    window.AMARJA_ADS_ID = ADS_ID;
  }

  // 4. Expose the Ads conversion target (with label) for the form-submit handler
  if (ADS_CONVERSION) {
    window.AMARJA_ADS_CONVERSION = ADS_CONVERSION;
  }
}
